import '../../App.css';
import React, {Component, Container} from 'react';
import {Row,Col,Image,Navbar, Nav, NavItem, NavDropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import YoutubeBackground from 'react-youtube-background';
import Card from './card';
import NavBarTop from "./navbar";
import Footer from "./footer";

var count = []

class TeacherList extends Component {
  constructor(props){
    super(props);
    this.state = {
       
    };

    this.setval = this.setval.bind(this)
    this.goprofile = this.goprofile.bind(this)
  }

  setval(obj){
    this.setState(obj)
  }
  goprofile(teacherid,region){
      const teacher = this.props.teacherlist[region][teacherid]
      this.props.setval({selectedTeacher:teacher})
  }
  componentDidMount(){
    document.title="International Classical Music Talent Competition"
    var link1 = document.getElementById('favicon')
    var link2 = document.getElementById('touchicon')
    link1.href="/assets/icmt_logo.PNG"
    link2.href="/assets/icmt_logo.PNG"
    this.props.setval({comp:"icmt"}) 
  }   
  componentWillUnmount(){
    this.props.setval({selectedTeacher:null})
  }   
      
  render(){

    return (
      <div>

      {(this.props.selectedTeacher==undefined) &&
      <div className="home-content-div" style={{textAlign:"justify",textJustify:"inter-word", padding:"4% 6%",fontFamily:"Courgette"}}>
        

        <div className='winners-banner'>
          <img src='/assets/winnerteacherbanner.PNG' alt='Winner Teacher'  />
        </div>
        <h2 className='winners-title'>International Classical Music Talent Competition</h2>
        <h5 className='winners-title'>Outstanding Music Teacher List</h5>

        <div style={{margin:"20px",textAlign:"justify"}}>
          <p>{"We deeply recognise efforts from teachers for their nurturing in a musician's journey. The list of Outstanding Music Teachers celebrate and mark the distinguished milestone of one's mentoring whose students also had the privilege to receive a winner prize."}</p>
        </div>


        <div style={{margin:"20px",textAlign:"justify"}}>

            <div style={{marginBottom:"15px",marginTop:"25px"}}>Hong Kong</div>
            {   (this.props.teacherlist["hk"]!= undefined) &&
                Object.keys(this.props.teacherlist["hk"]).map((key)=>{
                    return(
                        <div key={key}  className={"teacherlist-item"} onClick={(e)=>{
                          this.goprofile(key,"hk")
                        }}>
                            <em style={{fontSize:"1.4em",margin:"30px"}}>{this.props.teacherlist["hk"][key]["name"]}</em>
                        </div>
                    )
                })
            }
        

            <div style={{marginBottom:"15px",marginTop:"25px"}}>Indonesia</div>
            {   (this.props.teacherlist["in"]!= undefined) &&
                Object.keys(this.props.teacherlist["in"]).map((key)=>{
                    return(
                        <div key={key}  className={"teacherlist-item"} onClick={(e)=>{
                          this.goprofile(key,"in")
                        }}>
                            <em style={{fontSize:"1.4em",margin:"30px"}}>{this.props.teacherlist["in"][key]["name"]}</em>
                        </div>
                    )
                })
            }

            <div style={{marginBottom:"15px",marginTop:"25px"}}>Malaysia</div>
            {   (this.props.teacherlist["ml"]!= undefined) &&
                Object.keys(this.props.teacherlist["ml"]).map((key)=>{
                    return(
                        <div key={key}  className={"teacherlist-item"}   onClick={(e)=>{
                          this.goprofile(key,"ml")
                        }}>
                            <em style={{fontSize:"1.4em",margin:"30px"}}>{this.props.teacherlist["ml"][key]["name"]}</em>
                        </div>
                    )
                })
            }

             <div style={{marginBottom:"15px",marginTop:"25px"}}>Poland</div>
            {   (this.props.teacherlist["pl"]!= undefined) &&
                Object.keys(this.props.teacherlist["pl"]).map((key)=>{
                    return(
                        <div key={key}  className={"teacherlist-item"}   onClick={(e)=>{
                          this.goprofile(key,"pl")
                        }}>
                            <em style={{fontSize:"1.4em",margin:"30px"}}>{this.props.teacherlist["pl"][key]["name"]}</em>
                        </div>
                    )
                })
            }

             <div style={{marginBottom:"15px",marginTop:"25px"}}>Russia</div>
            {   (this.props.teacherlist["ru"]!= undefined) &&
                Object.keys(this.props.teacherlist["ru"]).map((key)=>{
                    return(
                        <div key={key}  className={"teacherlist-item"}   onClick={(e)=>{
                          this.goprofile(key,"ru")
                        }}>
                            <em style={{fontSize:"1.4em",margin:"30px"}}>{this.props.teacherlist["ru"][key]["name"]}</em>
                        </div>
                    )
                })
            }

          <div style={{marginBottom:"15px",marginTop:"25px"}}>Thailand</div>
              {   (this.props.teacherlist["th"]!= undefined) &&
                  Object.keys(this.props.teacherlist["th"]).map((key)=>{
                      return(
                          <div key={key} className={"teacherlist-item"}  onClick={(e)=>{
                            this.goprofile(key,"th")
                          }}>
                              <em style={{fontSize:"1.4em",margin:"30px"}}>{this.props.teacherlist["th"][key]["name"]}</em>
                          </div>
                      )
                  })
              }

        </div>

        <div style={{marginTop:"50px",fontSize:"0.8rem"}}>{"*The above list is arranged in alphabetical order."}</div>

           
        </div>
      }


      {(this.props.selectedTeacher!=undefined) &&
      
      <div style={{display:"flex",flexDirection:"column", marginBottom:"100px"}}>

        <div className={"about-goldbutton"} style={{display:"flex",flexDirection:"row",cursor:"pointer",width:"130px",marginLeft:"40px",marginTop:"40px",height:"60px"}} onClick={(e)=>{
          this.props.setval({selectedTeacher:null})
        }}>
          <img src="/assets/left-long-solid.svg" width={"15px"} height={"15px"} style={{margin:"5px"}} />
          <div style={{fontSize:"1rem"}}>&nbsp;&nbsp;&nbsp;{"Back"}</div>
        
        </div>

      <div className={"winner-teacher-div"}>

          <div className="jury-profile">
              <img src={"/assets/icmtteacher2024/"+this.props.selectedTeacher["name"]+".png"} alt="" width="100%" style={{padding:"30px"}} />
              </div>

          <div className="jury-text" style={{marginTop:"100px",marginRight:"80px",width:"100%",padding:"0% 5%"}}>
            <h4 style={{marginTop:"5px",marginBottom:"40px"}}><b>{this.props.selectedTeacher["name"]}</b></h4>
              <p>
                {
                  this.props.selectedTeacher["profile"]
                }
              </p>
          </div>
          
        </div>

     

  </div>

      }


      </div>
    );
  }
  }
  

export default TeacherList;
